import api from './api';

/** /api/email-domains — the current system's sender domains (the scope comes from the server, never from here) */
const call = async (promise) => {
  try {
    const { data } = await promise;
    return data;
  } catch (e) {
    throw new Error(e?.response?.data?.error || 'הפעולה לא הושלמה. יש לנסות שוב');
  }
};

export function emailDomainsApi() {
  return {
    list: (signal) => call(api.get('/email-domains', { signal })),
    inspect: (domain) => call(api.post('/email-domains/inspect', { domain })),
    create: (data) => call(api.post('/email-domains', data)),
    update: (id, data) => call(api.put(`/email-domains/${id}`, data)),
    action: (id, name, body) => call(api.post(`/email-domains/${id}/${name}`, body)),
  };
}
